import * as types from '@/store/types';
import { removeNamespaces } from '@/helpers/utils';

const localTypes = removeNamespaces(types);

export default {
  [localTypes.PAGES_SET](state, payload) {
    state.pages = payload;
  },
  [localTypes.PAGES_LOADING_SET](state, payload) {
    state.isPagesLoading = payload;
  },
};
